import React from "react";
import { Dashboard } from "./dashboard";

interface Props {}

export function DashboardRoute(props: Props) {
  return <Dashboard />;
}
